import { SpreadsheetRowData } from "@components/spreadsheet/types";
import { ReportPeriodWithLabel } from "@common/types/reports/types";
import { BalanceSheetViewRow } from "@components/accounting/balanceSheet/balanceSheetViewTypes";
import { LABEL_FIELD, periodField } from "../shared/reportTaskFields";

export interface BSSpreadsheetRow extends SpreadsheetRowData {
    _accountCodes?: string[];
    _periods?: ReportPeriodWithLabel[];
    children?: BSSpreadsheetRow[];
}

export function mapBSRowToSpreadsheet(
    row: BalanceSheetViewRow,
): BSSpreadsheetRow {
    const valueFields = Object.fromEntries(
        row.values.map((v, idx) => [periodField(idx), v]),
    );

    const result: BSSpreadsheetRow = {
        _id: row.id,
        _accountCodes: row.accountCodes,
        _periods: row.periods,
        _isTotal: row.isTotal,
        [LABEL_FIELD]: row.label,
        ...valueFields,
    };

    if (row.children && row.children.length > 0) {
        result.children = row.children.map(mapBSRowToSpreadsheet);
    }

    return result;
}

export function getDefaultExpandedIds(rows: SpreadsheetRowData[]): string[] {
    return rows.filter((r) => r.children?.length).map((r) => String(r._id));
}
